import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import VuejsDialog from 'vuejs-dialog'

Vue.use(Snotify, {
    toast: {
        position: SnotifyPosition.rightTop,
        showProgressBar: false
    }
})
Vue.use(VuejsDialog, {
    okText: 'Да',
    cancelText: 'Нет'
})

export default Snotify

const $snotify = Vue.prototype.$snotify
const $dialog = Vue.prototype.$dialog

export const toastSuccess = (message) => $snotify.success(message)

export const toastError = (message) => $snotify.error(message)

export const confirm = (title, message = '') => {
    return new Promise((resolve, reject) => {
        $dialog
            .confirm({
                title: title,
                body: message
            })
            .then(() => resolve(true))
            .catch(() => resolve(false))
    })
}

const MAX_TO_SHOW = 2

export const getUsageMessage = (usage) => {
    let vms = usage.vms ? usage.vms : []
    let planograms = usage.planograms ? usage.planograms : []
    let products = usage.products ? usage.products : []

    if (isEmpty(vms) && isEmpty(planograms) && isEmpty(products)) {
        return ''
    }

    let message = 'Удаление повлияет на:'

    vms.every(function (vm, index) {
        message += `\n * автомат Т${vm.id}`

        if (index >= (MAX_TO_SHOW - 1) && vms.length > MAX_TO_SHOW) {
            message += `\n * и еще ${vms.length - index}...`
            return false
        }

        message += `;`
        return true
    })

    planograms.every(function (planogram, index) {
        message += `\n * планограмму «${planogram.name}»`

        if (index >= (MAX_TO_SHOW - 1) && planograms.length > MAX_TO_SHOW) {
            message += ` и еще ${planograms.length - index - (MAX_TO_SHOW - 1)}...`
            return false
        }

        message += `;`
        return true
    })

    products.every(function (product, index) {
        message += `\n * рецепт «${product.name}»`

        if (index >= (MAX_TO_SHOW - 1) && products.length > MAX_TO_SHOW) {
            message += ` и еще ${products.length - index - (MAX_TO_SHOW - 1)}...`
            return false
        }

        message += `;`
        return true
    })

    return message
}
